<template>
    <div id="index">
        <div class="visible-xs">
            <div class="head_div flex_center">
                <i @click.stop="goLogin">
                    <img src="@/assets/img/esc_fan.png" alt="">
                </i>
                <h5 class="head_title flex_center">用户协议</h5>
            </div>
            <div class="center_text">
                更新日期:2020年07月07日
                <br>
                生效日期:2020年07月07日
                <br>
                欢迎您使用vision麻醉眼界服务（以下简称本服务），您在使用本服务前请认真阅读以下协议（以下简称本协议）。
                <br>
                一、vision麻醉眼界用户协议的接受
                当您在注册程序过程中在“已阅读，同意本《用户协议》”处打勾“√”并按照注册程序成功注册为vision麻醉眼界用户，或您以其他vision麻醉眼界允许的方式实际使用vision麻醉眼界服务时，即表示您已充分阅读、理解并接受本协议的全部内容，并与vision麻醉眼界达成协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，请您重点阅读并理解加粗提示条款。如您对本协议项下任何条款有异议，请停止使用麻醉眼界服务。
                <br>
                二、本协议的变更和修改
                vision麻醉眼界有权随时对本协议进行修改，并且一旦发生协议条款的变动，vision麻醉眼界将在相关页面上提示修改的内容；用户如果不同意本协议的修改，可以放弃使用或访问本网站或取消已经获得的服务；如果用户选择在本协议变更后继续访问或使用本网站，则视为用户已经接受本协议的修改。
                三、服务说明
                1、vision麻醉眼界是一个向广大用户提供文/图等稿件信息，供用户上传、分享原创信息的交流观看平台。
                <br>
                2、vision麻醉眼界运用自己的系统通过互联网向用户提供服务，除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品以及新增加的服务，均无条件地适用本协议。
                <br>
                四、用户行为
                用户需要实名认证完成账号注册，才能正常使用网站提供的服务。任何机构或个人注册和使用的互联网用户账号名称，必须符合《互联网用户账号名称管理规定》，用户必须承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。
                <br>
                1、用户账号、密码和安全
                （1）您在注册账号时必须通过实名认证，才能成为vision麻醉眼界的合法用户，得到一个密码和账号。您可以利用账户，通过本服务上传您的作品，合法正当地使用平台提供的各项服务功能。
                <br>
                （2）用户须对在vision麻醉眼界的注册信息的真实性、合法性、有效性承担全部责任，用户不得使用他人的名义发布任何信息；当被发现用户冒用他人或机构的名义恶意注册账号，vision麻醉眼界有权立即停止提供服务，收回其账号并由该用户承担由此而产生的一切法律及其他责任。
                <br>
                （3）您应采取合理措施维护其密码和账号的安全。用户对利用该密码和账号所进行的一切活动负全部责任；由该等活动所导致的任何损失或损害由用户承担，vision麻醉眼界不承担任何责任。
                （4）用户的密码和账号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知vision麻醉眼界，并且用户在每次连线结束，应结束账号使用，否则用户可能得不到vision麻醉眼界公司的安全保护。
                <br>
                （5）对于用户长时间未使用的账号，vision麻醉眼界有权予以关闭。
                <br>
                2、用户发布内容的传播
                （1）您同意授权vision麻醉眼界，有权通过本服务将您所上传的内容向全世界范围内不特定的网络用户展示。并授权vision麻醉眼界以宣传为目的，在署名作者的前提下免费地传播和使用您上传的内容。当任何第三方未经vision麻醉眼界同意，转载、抓取、盗链包含用户内容在内的vision麻醉眼界任何资料等行为时，用户同意并授权vision麻醉眼界有权以vision麻醉眼界的名义代表自己采取任何法律措施。
                <br>
                （2）您理解并同意，您上传至vision麻醉眼界的内容，若在上传过程中勾选了“禁止个人使用”，则未经您或vision麻醉眼界的正式授权，任何个人或组织不得转载、保存或采集至任何第三方空间。若您在上传过程中勾选了“禁止匿名转载”，则任何个人及组织不得匿名转载您上传的内容至任何第三方空间。否则vision麻醉眼界对前述行为有权要求第三方断开链接、删除并有权以vision麻醉眼界的名义提起诉讼，以维护您的合法权益。
                <br>
                （3）如果您通过本服务分享作品，则您保证：
                <br>
                a 您所分享的作品均由您本人原创或已经依法获得原始权利人合法授权。
                <br>
                b 您有权授权vision麻醉眼界依据本服务的相关规则使用您的作品，包括但不限于将您上传的图片向其他用户推荐或推广。
                <br>
                c 您所上传的图片符合国家相关法律法规和公序良俗，不会损害任何他方的合法权益或造成不良社会影响。
                <br>
                d vision麻醉眼界依照本服务的规则使用您的作品，无须另行获得第三方同意或对第三方承担任何责任。
                <br>
                3、禁止用户从事以下行为：
                （1）反对宪法所确定的基本原则的；
                <br>
                （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                <br>
                （3）损害国家荣誉和利益的；
                <br>
                （4）煽动民族仇恨、民族歧视，破坏民族团结的；
                <br>
                （5）破坏国家宗教政策，宣扬邪教和封建迷信的；
                <br>
                （6）散布谣言，扰乱社会秩序，破坏社会稳定的；
                <br>
                （7）散布淫秽、赌博、暴力、凶杀、自残、恐怖或者教唆犯罪的；
                <br>
                （8）侮辱或者诽谤他人，侵害他人合法权益（如名誉权、肖像权等）的；
                <br>
                （9）侵害他人知识产权、商业秘密等合法权利的；
                <br>
                （10）虚构事实、隐瞒真相以误导、欺骗他人的；
                <br>
                （11）发布、传送、传播广告信息及垃圾信息的；
                <br>
                （12）其他法律法规禁止的行为。
                <br>
                如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容，或者侵犯任何第三方的合法权益，您将直接承担以上导致的一切不利后果。
                <br>
                4、用户对经由本网站上载、张贴、发送电子邮件或传送的内容承担全部责任
                （1）对于用户经由vision麻醉眼界传送的内容，vision麻醉眼界不保证其合法性、正当性、准确性、完整性或品质。用户在接受本网站服务后，在任何情况下，vision麻醉眼界均不对任何内容承担任何责任，包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。vision麻醉眼界有权（但无义务）自行拒绝或删除经由本网站提供的任何内容。
                <br>
                （2）vision麻醉眼界有权利在下述情况下，对内容进行保存或披露：
                <br>
                a 法律程序所规定；
                <br>
                b 本服使用协议规定；
                <br>
                c 被侵害的第三人提出权利主张；
                <br>
                d 为保护vision麻醉眼界、其使用者及社会公众的权利、财产或人身安全；
                <br>
                e 其他vision麻醉眼界认为有必要的情况。
                <br>
                5、对用户发布信息的存储和披露
                vision麻醉眼界不对用户所发布信息的删除或储存失败承担责任。请用户另行存储备份。vision麻醉眼界有权判断用户的行为是否符合本协议规定，如果vision麻醉眼界认为用户违背了协议条款规定，有终止向其提供网站服务的权利。
                <br>
                6、用户同意遵守麻醉眼界规则、常见问题解答等vision麻醉眼界管理规定。
                五、关于个人信息保护
                vision麻醉眼界深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。在您使用vision麻醉眼界提供的产品或服务的过程中，您同意按照vision麻醉眼界发布的隐私政策收集、使用、存储、共享、披露和保护您的个人信息。如vision麻醉眼界网站、客户端或关联公司的网站、客户端未设独立隐私政策的，则vision麻醉眼界或vision麻醉眼界关联公司参照适用麻醉眼界隐私政策要求保护您的个人信息。请在注册vision麻醉眼界用户前，仔细阅读vision麻醉眼界隐私政策，以了解vision麻醉眼界如何处理和保护您的个人信息。
                <br>
                六、版权声明
                1、vision麻醉眼界会员所发布展示的“原创作品”、“原创文章”等原创内容，版权由作者享有和解释，任何商业用途均须联系原作者。临摹作品，同人作品原型版权归原作者所有。
                <br>
                2、原创内容的发布者必须确保其拥有发布内容的全部完整版权，或已经获得版权所有者的合法授权，不得侵犯他人著作权、肖像权、商标权等合法权益，不违背商业保密协议。vision麻醉眼界默认所有原创类的内容的发布者已经获得发表、演绎、信息网络传播等版权授权。若因发布内容产生法律纠纷，全部责任在于用户本人，vision麻醉眼界不承担任何法律责任。
                <br>
                3、用户在vision麻醉眼界上发布的内容，视为授权其作品使用在vision麻醉眼界平台上，并授予vision麻醉眼界免费的、全球的、不可撤销的非独家使用许可，vision麻醉眼界有权将该内容用于vision麻醉眼界各种形态的产品和服务上，包括但不限于vision麻醉眼界网站以及vision麻醉眼界官方发布的适用于手持终端设备的应用或其他互联网产品。
                <br>
                4、如果任何第三方侵犯了vision麻醉眼界用户相关的权利，用户同意授权vision麻醉眼界或其指定的代理人代表vision麻醉眼界自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉（但非义务），或谈判和解，并且用户同意在vision麻醉眼界认为必要的情况下参与共同维权。
                <br>
                5、在未得到著作权人的授权时，请不要将他人的作品全部或部分复制发表到vision麻醉眼界，如转载站外信息到vision麻醉眼界请署名和注明出处，并取得著作权人许可。用户应承担相应的不利后果，麻醉眼界对此不承担任何责任。
                6、如个人或单位发现vision麻醉眼界上存在侵犯其自身合法权益的内容，请及时与vision麻醉眼界取得联系，并提供具有法律效应的证明材料，以便vision麻醉眼界作出处理。vision麻醉眼界有权（无义务）根据实际情况删除相关的内容，并追究相关用户的法律责任。给vision麻醉眼界或任何第三方造成损失的，侵权用户应负全部责任。
                <br>
                7、未经vision麻醉眼界许可，任何人不得复制、转载、盗链、上载、下载、展示麻醉眼界上的任何资源、；不得复制或仿造本站或者在非vision麻醉眼界所属服务器上建立镜像。否则，vision麻醉眼界将依法追究法律责任。
                <br>
                8、vision麻醉眼界的标识、源代码、及所有页面的版式设计等，版权归vision麻醉眼界所有。未经授权，不得用于除vision麻醉眼界之外的任何站点。
                <br>
                七、免责声明
                1、除vision麻醉眼界注明的服务条款外，其它因使用vision麻醉眼界而导致任何意外、疏忽、合约毁坏、诽谤、版权或知识产权侵犯及其所造成的各种损失（包括因下载而感染电脑病毒），vision麻醉眼界概不负责，亦不承担任何法律责任。
                2、vision麻醉眼界不保证（包括但不限于）：
                （1）本网站适合用户的使用要求；
                （2）本网站不受干扰，及时、安全、可靠或不出现错误；
                （3）用户经由本网站取得的任何产品、服务或其他材料符合用户的期望。
                3、本服务可能会包含与其他网站或资源的链接，即第三方链接。vision麻醉眼界对于前述网站或资源的内容、隐私政策和活动，无权控制、审查或修改，因而也不承担任何责任。建议您在离开vision麻醉眼界服务，访问其他网站或资源前仔细阅读其服务条款和隐私政策。
                4、因用户内容在本网站的上载或发布，而导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户承担全部责任，vision麻醉眼界不承担任何责任。
                5、vision麻醉眼界内会员所发言论仅代表网友自己，并不反映任何vision麻醉眼界之意见及观点。
                6、vision麻醉眼界认为，一切网民在进入vision麻醉眼界主页及各层页面时已经仔细看过本条款并完全同意。
            </div>
        </div>
    </div>
</template>
<script>

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";

    export default {
        name: "index",
        data() {
            return {

            };
        },
        computed: {},
        components: {

        },
        watch: {

        },
        methods: {
            goLogin() {//返回登录
                this.$router.go(-1)
            },


        },
        mounted() {
            let that = this;
            if (this._isMobile()) {
                // alert("手机端");
                //   this.$router.replace('/m_index');
            } else {
                // alert("pc端");
                this.$router.replace("/");
            }
        }
    };
</script>
<style scoped>
    html,
    body {
        max-width: 100vw;
    }

    .visible-xs {
        width: calc(100% - 4rem);
        overflow: hidden;
        padding-top: 0rem;
        padding: 50px 2rem 1.6rem 2rem;

    }

    .head_div {
        position: fixed;
        padding: 0 2rem;
        height: 50px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        background: #fff;
    }

    .head_div>i {
        width: 1.8rem;
        position: absolute;
        left: 2rem;
        top: 0;
        height: 50px;
        z-index: 999;
    }

    .head_div .head_title {
        flex: 1;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        font-size: 1.6rem;
        color: #333;
    }

    .logo_div {
        position: fixed;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100vw - 4rem);
    }

    .title {
        margin-top: 5rem;
        font-size: 2rem;
        color: 333;
        font-weight: bold;
    }

    .center_text {
        font-size: 1.4rem;
        line-height: 1.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/tool/user_agreement.vue